import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const AnnouncementCreate=React.lazy(()=>import('./NewAnnouncement'))
const AnnouncementEdit=React.lazy(()=>import('./EditAnnouncement'))
const AnnouncementTable=React.lazy(()=>import('./AnnouncementLisiting'));
const Dummyeditior= React.lazy(()=>import ('./dummyckeditor'));

export const AnnouncementConfigs = [
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/announcement/create',
    element: <AnnouncementCreate />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/announcement/edit/:id',
    element: <AnnouncementEdit />,
  },

  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/announcement/list',
    element: <AnnouncementTable/>,
  },

  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/announcement/ckeditor',
    element: <Dummyeditior/>,
  },
];
